"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (mock, resourceUrl, mocks, config) {
    if (config) {
        config.create(mock, resourceUrl, mocks);
        config.read(mock, resourceUrl, mocks);
        config.readAll(mock, resourceUrl, mocks);
        config.update(mock, resourceUrl, mocks);
        config.delete(mock, resourceUrl, mocks);
    }
    else {
        mock.onGet("/" + resourceUrl + "/:id").reply(200, mocks[0]);
        mock.onGet("/" + resourceUrl).reply(200, mocks);
        mock.onPost("/" + resourceUrl).reply(200, mocks[0]);
        mock.onPut("/" + resourceUrl + "/:id").reply(200, mocks[0]);
        mock.onDelete("/" + resourceUrl + "/:id").reply(200, undefined);
    }
});
